import { useState } from 'react';
import { LoadingComponent } from '../../../../components/loadingComponent/LoadingComponent';
import NoRecordFound from '../../../../components/noRecord/NoRecordFound';
import TableHeading from '../../../../components/tableHeading/TableHeading';
import TableSettingMenu from '../../../../components/tableHeading/TableSettingMenu';
import TextField from '../../../../components/textFields/TextField';
import { useGetKeysandValuesOfServiceByServiceIdQuery } from '../../../../services/SystemSettingsApi';
import useColumnVisibility from '../../../customHooks/useColumnVisibility';
import labelKey from '../../../localization/label.json';
import VersionSettingModal from './VersionSettingModal';
import { KTSVG } from '../../../../_metronic/helpers';
import { Tooltip } from 'react-tooltip';
const VersionsSettings = ({ serviceId }: any) => {
  const { hiddenColumns, handleToggleColumn } = useColumnVisibility({ pageName: 'versionKeys' });
  const { data, isLoading, refetch } = useGetKeysandValuesOfServiceByServiceIdQuery({ ServiceId: serviceId })
  const [showVersionSettingModal, setShowVersionSettingModal] = useState(false)
  const [showVersionData, setShowVersionData] = useState({})
  const versionModalHandler = () => {
    setShowVersionSettingModal((prev) => !prev);
  };
  return (
    <>
      <VersionSettingModal
        show={showVersionSettingModal}
        handleClose={() => setShowVersionSettingModal(false)}
        data={showVersionData}
        serviceId={serviceId}
        refetch={refetch} />

      <div className='card mb-5 mb-xl-10' style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
        <div className='d-flex align-items-center py-3 px-12'>
          <button className='btn btn-sm btn-light-primary ms-auto'
            onClick={() => {
              setShowVersionData(true);
              versionModalHandler();
            }}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
            {labelKey.addKey}
          </button>
        </div>
        <div className='card-body px-9 py-1'>
          <div className='table-responsive table-height'>
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <thead>
                <tr className='fw-bold text-muted'>
                  {hiddenColumns.includes('sr') && (
                    <TableHeading
                      label={labelKey.sr}
                      columnId='sr'
                      className="ps-4"
                    />
                  )}
                  {hiddenColumns.includes('key') && (
                    <TableHeading
                      label={labelKey.key}
                      columnId='key'

                    />
                  )}
                  {hiddenColumns.includes('value') && (
                    <TableHeading
                      label={labelKey.value}
                      columnId='value'
                    />
                  )}
                  <th className='text-end rounded-end pe-2 border-0'>
                    {hiddenColumns.includes('actions') && (
                      <>
                        {labelKey.actions}
                      </>
                    )}
                    <TableSettingMenu>
                      <TextField
                        rightLabel={labelKey.sr}
                        type="checkbox"
                        onChange={() => handleToggleColumn("sr")}
                        checked={hiddenColumns.includes('sr')}
                        fieldClass='mb-4'
                      />
                      <TextField
                        rightLabel={labelKey.key}
                        type="checkbox"
                        onChange={() => handleToggleColumn("key")}
                        checked={hiddenColumns.includes('key')}
                        fieldClass='mb-4'
                      />
                      <TextField
                        rightLabel={labelKey.value}
                        type="checkbox"
                        onChange={() => handleToggleColumn("value")}
                        checked={hiddenColumns.includes('value')}
                        fieldClass='mb-4'
                      />
                      <TextField
                        rightLabel={labelKey.actions}
                        type="checkbox"
                        onChange={() => handleToggleColumn("actions")}
                        checked={hiddenColumns.includes('actions')}
                        fieldClass='mb-4'
                      />
                    </TableSettingMenu>
                  </th>

                </tr>
              </thead>
              <tbody>
                {!isLoading &&
                  <>
                    {data?.result?.length > 0 ? (
                      <>
                        {data?.result?.map((data: any, index: any) => (
                          <tr key={index}>
                            {hiddenColumns.includes('sr') && (
                              <td className='ps-4'>{index + 1}</td>
                            )}
                            {hiddenColumns.includes('key') && (
                              <td>{data?.key}</td>
                            )}
                            {hiddenColumns.includes('value') && (
                              <td>{data?.value}</td>
                            )}
                            {hiddenColumns.includes('actions') && (
                              <td>
                                <div className='d-flex align-items-center justify-content-end gap-2' >
                                  <Tooltip id={labelKey.updateKey} place="top" />
                                  <div
                                    data-tooltip-id={labelKey.updateKey} data-tooltip-content={labelKey.updateKey}
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    onClick={() => {
                                      setShowVersionData(data);
                                      versionModalHandler();
                                    }}
                                  >
                                    <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                                  </div>
                                </div>
                              </td>
                            )}
                          </tr>
                        ))}
                      </>) : (
                      <tr>
                        <td colSpan={7}>
                          <NoRecordFound />
                        </td>
                      </tr>
                    )}
                  </>}
                {isLoading && (
                  <tr>
                    <td colSpan={7} className="text-center">
                      <LoadingComponent />
                    </td>
                  </tr>
                )}
              </tbody>
              {/* end::Table body */}
            </table>
          </div>
        </div>
      </div>
    </>
  )
}

export default VersionsSettings